import { Col } from "reactstrap";
import PlaylistData from "../playlist/data/PlaylistData";
import { OrderByButton } from "../common/components/multiselectablelist/OrderByButton";
import { MultiChangeToolbar } from "./MultiChangeToolbar";
import { FilterHeader } from "./FilterHeader";
import { useTranslation } from "react-i18next";

interface Props {
  changeOrderBy: (newField: keyof PlaylistData) => void;
  orderByAscOrDesc: "asc" | "desc";
  orderByField: keyof PlaylistData;
  performSearch: (searchTerm: string) => void;
  selectedPlaylists: readonly PlaylistData[];
  currentCrewIdentifier: string | undefined;
  setCurrentCrewIdentifier: (i: string | undefined) => void;
  performIndexRefresh: () => void;
}

export function PlaylistIndexHeaderColumns({
  changeOrderBy,
  orderByAscOrDesc,
  orderByField,
  performSearch,
  selectedPlaylists,
  currentCrewIdentifier,
  setCurrentCrewIdentifier,
  performIndexRefresh,
}: Props) {
  const { t } = useTranslation();

  function OrderBy(orderByProps: {
    title: string;
    field: keyof PlaylistData;
    dataCy?: string;
  }) {
    return (
      <OrderByButton
        title={orderByProps.title}
        field={orderByProps.field}
        changeOrderBy={changeOrderBy}
        currentField={orderByField}
        currentOrder={orderByAscOrDesc}
        dataCy={orderByProps.dataCy}
      />
    );
  }

  return (
    <>
      <Col xs={12} lg={8}>
        {/*We don't remove the element but only hide it to not lose he state when it's not visible.*/}
        <FilterHeader
          OrderByBuilder={OrderBy}
          performSearch={performSearch}
          visible={selectedPlaylists.length === 0}
          currentCrewIdentifier={currentCrewIdentifier}
        />
        {selectedPlaylists.length > 0 && (
          <MultiChangeToolbar
            currentCrewIdentifier={currentCrewIdentifier}
            setCurrentCrewIdentifier={setCurrentCrewIdentifier}
            selectedPlaylists={selectedPlaylists}
            performIndexRefresh={performIndexRefresh}
          />
        )}
      </Col>
      <Col className="d-none d-lg-block" lg={2}>
        <OrderBy title={t("common.created")} field="createdAt" />
      </Col>
      <Col className="d-none d-lg-block" lg={2}>
        <OrderBy title={t("common.updated")} field="updatedAt" />
      </Col>
    </>
  );
}
